import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { navigateWizard } from '../../actions';
import { useAuth } from '../../lib/authContext';
import useMobileScreen from '../../lib/hooks/useMobileScreen';
import { wizardPathsSelector } from '../../reducers/selectors';
import BackActionButton from '../BackActionButton';
import ProgressBar from '../ProgressBar';

const matchPaths = ['/class-under-review', '/full-time-job', '/eligible'];

const backThree = ['/ineligible'];

const MainContainerApp = ({
  Routes,
  showMainNavigation,
  navigation,
  wizardPaths,
  dispatchWizardNav,
}) => {
  const location = useLocation();
  const isMatched = matchPaths.includes(location.pathname);
  const isMatchedThree = backThree.includes(location.pathname);
  const { isAuthenticated } = useAuth();
  const isMobile = useMobileScreen();
  const lastPath = navigation[navigation.length - 1];
  const currentPathIndex = useMemo(() => {
    return wizardPaths.map(p => p.url).indexOf(lastPath);
  }, [lastPath, wizardPaths]);

  const backAction = () => {
    if (isMatched) {
      dispatchWizardNav({ dir: 'back' });
      dispatchWizardNav({ dir: 'back' });
    } else if (isMatchedThree) {
      dispatchWizardNav({ dir: 'back' });
      dispatchWizardNav({ dir: 'back' });
      dispatchWizardNav({ dir: 'back' });
    } else {
      dispatchWizardNav({ dir: 'back' });
    }
  };

  const nisoClass = useMemo(() => {
    let className = '';
    if (currentPathIndex > -1) {
      if (currentPathIndex < 2) {
        className = 'pt-5 container';
      } else {
        className = 'back-grey container-padding-x';
      }
    }

    return className;
  }, [currentPathIndex]);

  return (
    <>
      {isAuthenticated && showMainNavigation && (
        <ProgressBar
          wizardPaths={wizardPaths}
          lastPath={lastPath}
          currentPathIndex={currentPathIndex}
          backAction={backAction}
        />
      )}
      <div className={`niso-route-container ${nisoClass}`}>
        {currentPathIndex > 1 && !isMobile && <BackActionButton action={backAction} />}
        {Routes}
      </div>
    </>
  );
};

MainContainerApp.propTypes = {
  Routes: PropTypes.shape({}).isRequired,
  showMainNavigation: PropTypes.bool.isRequired,
  navigation: PropTypes.arrayOf(PropTypes.string).isRequired,
  wizardPaths: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
};

export const mapStateToProps = state => ({
  navigation: state.navigation,
  wizardPaths: wizardPathsSelector(state),
});

export const mapDispatchToProps = {
  dispatchWizardNav: navigateWizard,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainContainerApp);
